export const getInitialState = (): any => ({
  actionsPreviewData: {},
  actionsPreviewStatus: 0
});
